const VIDEO_TYPE = /video\/(mp4|webm|ogg)$/i;
const IMAGE_TYPE = /image\/.*$/i;

export default function getSectionBackgroundStyle({ data, styles }, style = {}) {
  const backgroundStyle = { ...styles.background, ...style };

  if (data.repeatBackgroundImage) {
    backgroundStyle.backgroundRepeat = 'repeat';
  } else {
    backgroundStyle.backgroundSize = 'cover';
  }

  if (data.backgroundMedia && IMAGE_TYPE.test(data.backgroundMedia.type)) {
    backgroundStyle.backgroundImage = `url(${data.backgroundMedia.url})`;
  }

  if (
    data.backgroundMedia &&
    VIDEO_TYPE.test(data.backgroundMedia.types) &&
    data.backgroundMedia.preview
  ) {
    backgroundStyle.backgroundImage = `url(${data.backgroundMedia.preview})`;
  }

  return backgroundStyle;
}



// WEBPACK FOOTER //
// ./src/site-render/src/lib/getSectionBackgroundStyle.js